import { useState } from "react";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import axios from "axios";

const forgotPasswordUrl = `${process.env.REACT_APP_BACKEND_URL}/api/auth/forgot-password`;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError("");
    setMessage("");
    setIsSubmitting(true);
    try {
      const response = await axios.post(forgotPasswordUrl, { email });
      setMessage(response.data.message);
    } catch (requestError) {
      setError(requestError.response?.data?.detail || "We couldn't send a reset link. Try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <main className="recovery-page" data-testid="forgot-password-page">
      <section className="recovery-panel">
        <Link className="back-link" to="/login" data-testid="back-to-login-link">
          <ArrowLeft size={16} strokeWidth={1.8} />
          Back to sign in
        </Link>
        <p className="eyebrow">Account recovery</p>
        <h1 data-testid="forgot-password-heading">Reset your password</h1>
        <p className="recovery-description" data-testid="forgot-password-description">
          Enter your account email and we’ll send a secure link to choose a new password.
        </p>
        <form className="recovery-form" onSubmit={submit} data-testid="forgot-password-form">
          <label className="auth-field" data-testid="forgot-password-email-field">
            <span>Email address</span>
            <input
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              type="email"
              autoComplete="email"
              placeholder="you@example.com"
              required
              data-testid="forgot-password-email-input"
            />
          </label>
          {message && <p className="recovery-success" data-testid="forgot-password-success">{message}</p>}
          {error && <p className="auth-error" data-testid="forgot-password-error">{error}</p>}
          <button
            className="email-submit-button"
            type="submit"
            disabled={isSubmitting}
            data-testid="forgot-password-submit-button"
          >
            {isSubmitting ? "Sending…" : "Send reset link"}
          </button>
        </form>
      </section>
    </main>
  );
}